import Model, { attr } from '@ember-data/model';

export default class ZapierApiKeyModel extends Model {
  @attr('string') token!: string;
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'zapier-api-key': ZapierApiKeyModel;
  }
}
